<template>
	<div>
		<v-card flat tile class="surfaceDark darken-1 d-flex justify-center">
			<v-card-text class="col-10">
				<v-row>
					<v-col class="d-flex align-center">
						<v-img alt="UX" 
						class="shrink mr-2" 
						contain src="../../assets/uxlogo.svg" 
						width="80" 
						style="cursor:pointer" />
					</v-col>
					<v-col class="d-flex justify-center align-center">
						<v-img 
						alt="UX" 
						class="shrink mr-2" 
						contain 
						src="../../assets/footer/sponsors/vue-logo.png" 
						width="60" 
						style="cursor:pointer" />
						<span class="text-overline text-left primary--text text--lighten-1 font-weight-bold ">CREATED FROM VUE</span>
					</v-col>

					<v-col class="d-flex justify-center align-center">
						<v-img
							alt="UX"
							class="shrink mr-2"
							contain
							src="../../assets/footer/sponsors/vuetify-logo.png"
							width="80"
							style="cursor:pointer"
						/>
						<span class="text-overline text-left primary--text text--lighten-1 font-weight-bold "
							>VUETIFY LIBRARY</span
						>
					</v-col>
					<!-- <v-col class="d-flex">
						<v-col class="d-flex flex-column">
							<span class="text-overline text-left primary--text text--lighten-1 font-weight-bold">SECURITY AND TRUST</span>
							<v-img
								alt="UX"
								class="shrink mt-2"
								contain
								src="../../assets/footer/sponsors/securityTrust.png"
								width="80"
								style="cursor:pointer"
							/>
						</v-col>
						<v-col class="d-flex flex-column">
							<span class="text-overline text-left primary--text text--lighten-1 font-weight-bold">RESPONSIBLE GAMING</span>
							<v-img
								alt="UX"
								class="shrink mt-2"
								contain
								src="../../assets/footer/sponsors/responsibleGaming.png"
								width="120"
								style="cursor:pointer"
							/>
						</v-col>
					</v-col> -->
				</v-row>
			</v-card-text>
		</v-card>
		<v-divider></v-divider>
		<v-card flat tile class="surfaceDark darken-1 d-flex justify-center text-center pb-2">
			<v-card-text class="col-10">
				<span class="text-caption primary--text text--darken-3"
					>{{ companyInfo.trademark }} <br />
					{{ companyInfo.license }}
				</span>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
export default {
	data() {
		return {}
	},
	computed: {
		companyInfo() {
			return this.$store.getters["Footer/companyInfo"]
		},
	},
}
</script>

<style lang="sass" scoped>
.v-application .text-overline
	letter-spacing: -0.1px !important
.v-card__subtitle, .v-card__text, .v-card__title
	padding: 24px 0 !important
</style>
